import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-only-layout',
  templateUrl: './header-only-layout.component.html',
  styleUrls: ['./header-only-layout.component.scss']
})
export class HeaderOnlyLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
